import { useEffect, useState } from "react";
import axios from "axios";
import { defaultContent } from "../data/site";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const readPreview = () => {
  try {
    const isPreview = new URLSearchParams(window.location.search).get("preview") === "1";
    if (!isPreview) return null;
    const draft = JSON.parse(localStorage.getItem("mk_preview_content") || "null");
    return draft ? { ...defaultContent, ...draft } : null;
  } catch (error) {
    return null;
  }
};

export const useSiteContent = () => {
  const [content, setContent] = useState(() => readPreview() || defaultContent);
  useEffect(() => {
    if (readPreview()) return undefined;
    let active = true;
    axios.get(`${API}/content`).then(({ data }) => {
      if (active && data && Object.keys(data).length) {
        setContent({ ...defaultContent, ...data });
      }
    }).catch(() => {});
    return () => {
      active = false;
    };
  }, []);
  return content;
};
